var React = require('react');

function Back (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 1L2 8.5L10 16","stroke":"black","strokeWidth":"2.5"}));
}

Back.defaultProps = {"width":"11","height":"17","viewBox":"0 0 11 17","fill":"none"};

module.exports = Back;

Back.default = Back;
